module.exports = __webpack_public_path__ + "static/media/rie9.ac04bff6.jpg";